<template>
  <div>
    <v-list-item class="user-card">
      <v-list-item-icon style="min-height: 32px">
        <StatusAvatar :user="user" avatar-size="36px" badge-size="12px"/>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ user.exten }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ user.name }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-btn :disabled="!canWrite" icon small
              @click="toggleWatch()" v-on="on" class="toggle-watch">
              <v-icon small :color="isBuddy ? 'green' : 'grey lighten-2'">
                mdi-eye{{ isBuddy ? '' : '-off' }}
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ isBuddy ? $t('buddy.tooltip.unwatch') : $t('buddy.tooltip.watch') }}
          </span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'user',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: { StatusAvatar },
  computed: {
    ...mapGetters({
      canWrite: 'permissions/usersWrite',
      isUserBuddy: 'users/isUserBuddy'
    }),
    isBuddy: function () {
      return this.isUserBuddy(this.user)
    }
  },
  methods: {
    ...mapActions({
      startWatch: 'users/startWatchUser',
      stopWatch: 'users/stopWatchBuddy'
    }),
    toggleWatch: function () {
      /* istanbul ignore next */
      if (this.isBuddy) {
        this.stopWatch(this.user)
      } else {
        this.startWatch(this.user)
      }
    }
  }
}
</script>

<style scoped>
</style>
